import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Wind, HandHeart, Sparkles, Zap, Sun, Star } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IubireBenefits() {
  const benefits = [{
    icon: Heart,
    title: 'Înveți să te iubești pe tine cu adevărat',
    desc: 'Nu mai aștepți ca altcineva să îți dea validarea de care ai nevoie. Înveți să ți-o dai singur/ă, prin exerciții practice care îți schimbă relația cu tine.'
  }, {
    icon: Wind,
    title: 'Eliberezi resentimentele acumulate',
    desc: 'Durerea, furia, dezamăgirea, toate cele pe care le-ai ținut în tine se eliberează. Nu le mai porți. Le lași să plece.'
  }, {
    icon: HandHeart,
    title: 'Practici iertarea și vindecarea emoțională',
    desc: 'Iertarea devine o practică reală, nu doar un concept frumos. Ierți pe ceilalți, dar mai ales te ierți pe tine.'
  }, {
    icon: Sparkles,
    title: 'Te reconectezi la iubire autentică',
    desc: 'Nu iubire de suprafață, nu iubire condiționată. Iubire reală, profundă, care vine din interior și se revarsă în relațiile tale.'
  }, {
    icon: Zap,
    title: 'Crești vibrația energetică',
    desc: 'Prin meditații ghidate accesezi o stare de energie și pace pe care o simți în corp și în minte. Nu e abstract. E o stare pe care o trăiești.'
  }, {
    icon: Sun,
    title: 'Accesezi pace și împlinire interioară',
    desc: 'Golul interior se umple. Nu cu lucruri din exterior, ci cu iubirea pe care o descoperi în tine. Și de acolo totul se schimbă.'
  }, {
    icon: Star,
    title: 'Experimentezi iubirea la un nivel profund',
    desc: 'Inclusiv la nivel spiritual. Mulți participanți descriu experiența meditațiilor ca fiind cel mai frumos lucru pe care l-au trăit vreodată.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1426">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1427">
        <SectionHeading title="Ce se schimbă concret după acest curs" data-id="element-1428" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1429">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-1430">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-1431">
                  <Icon className="w-8 h-8" data-id="element-1432" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-1433">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-1434">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1435">
          <CTAButton data-id="element-1436" />
        </motion.div>
      </div>
    </section>;
}